document.addEventListener('DOMContentLoaded', function () {
	const printButtons = document.querySelectorAll('.btn-print');
	printButtons.forEach(function (button) {
		button.addEventListener('click', function (e) {
			e.preventDefault();
			window.print();
		});
	});
});
